import React from "react";
import { Link } from "react-router-dom";
import mockMac from "./mockMac";
import "./Mac.scss";

const Mac = () => {
  return (
    <div className="Mac">
      {mockMac.map((product) => (
        <div className="Mac-container">
          <Link
            className="Mac-container_card"
            key={product.id}
            to={`/MacDetail/${product.id}`}
          >
            <img className="Mac-container_card--img" src={product.img}></img>
            <h2 className="Mac-container_card--txt">{product.model}</h2>
          </Link>
        </div>
      ))}
    </div>
  );
};

export default Mac;
